import React from 'react';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Box,
  Button,
  Container,
  Typography
} from '@material-ui/core';

import { logoutUser } from 'redux/actions';
import { single } from 'variables/userAccountTypes';

import socket from 'config/socket';

const mapStateToProps = (state) => ({
  activeUserType: state.activeUserType
});

const NotFound = (props) => {
  const navigate = useNavigate();

  const navigateToDashboard = () => {
    navigate('/app/dashboard', { replace: true })
  };

  const handleLogout = () => {
    if(props.activeUserType !== single && socket.connected) {
      socket.emit('leave-rooms');
      socket.removeAllListeners();
    }

    props.logoutUser();
    navigate('/login', { replace: true });
  };

  return (
    <React.Fragment>
      <Box
        sx={{
          backgroundColor: 'background.default',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          justifyContent: 'center'
        }}
      >
        <Container maxWidth="md">
          <Typography
            align="center"
            color="textPrimary"
            variant="h1"
          >
            404: The page you are looking for isn’t here
          </Typography>
          <Typography
            align="center"
            color="textPrimary"
            variant="subtitle2"
          >
            You either tried some shady route or you came here by mistake.
            Whichever it is, try using the navigation
          </Typography>
          <Box sx={{ textAlign: 'center' }}>
          <Button
              color="primary"
              variant="contained"
              onClick={navigateToDashboard}
            >
              Back to Dashboard
            </Button>
            <Button
                variant="contained"
                onClick={handleLogout}
              >
                Logout
            </Button>
          </Box>
        </Container>
      </Box>
    </React.Fragment>
  )
};

export default connect (mapStateToProps, {logoutUser}) (NotFound);
